<main>

  <!-- <div class="title">
    <span>Ficha Médica do Aluno: {{nomeAluno}}</span>
  </div> -->

  <app-tabs [tabs]="tabs" (change)="changeTabs($event)"></app-tabs>

  @switch (tabsSelecionada) {
  @case ('ficha-medica') {
  @if(!editar) {
  <section class="desktop">

    @if(aluno.ficha_medica === null) {
    <div class="empty">
      <img src="assets/images/turma-empty.png" alt="">
      <span>Nenhuma ficha médica encontrada !</span>
      <h4>Que tal cadastrar agora mesmo ?</h4>
      <tgt-button [size]="'small'" [border]="false" [color]="'primary'" [fieldButton]="'field'" [icon]="'add'"
        (click)="editarForm()">Cadastrar Ficha Médica</tgt-button>
    </div>
    } @else {
    <div class="esquerda">
      <div class="content-esquerda">
        <span>Peso</span>
        <span>{{ aluno && (aluno.ficha_medica.peso ? aluno.ficha_medica.peso : 'Não informado') }}</span>
      </div>
      <div class="content-esquerda">
        <span>Altura</span>
        <span>{{ aluno && (aluno.ficha_medica.altura ? aluno.ficha_medica.altura : 'Não informado') }}</span>
      </div>
      <div class="content-esquerda">
        <span>Grupo Sanguíneo</span>
        <span>{{ aluno && (aluno.ficha_medica.tipoSanguineo ? aluno.ficha_medica.tipoSanguineo : 'Não informado') }}</span>
      </div>
      <div class="content-esquerda">
        <span>Fator RH</span>
        <span>{{ aluno && (aluno.ficha_medica.fatorrh ? aluno.ficha_medica.fatorrh : 'Não informado') }}</span>
      </div>
      <div class="content-esquerda">
        <span>Número da Carteira do SUS</span>
        <span>{{ aluno && (aluno.ficha_medica.carteiraSus ? aluno.ficha_medica.carteiraSus : 'Não informado') }}</span>
      </div>
      <div class="content-esquerda">
        <span>O aluno é alérgico a algum medicamento?</span>
        <span>{{ aluno && (aluno.ficha_medica.alergicoMedicamento ? aluno.ficha_medica.alergicoMedicamento : 'Não informado') }}</span>
      </div>
      <div class="content-esquerda">
        <span>O aluno é alérgico a algum alimento?</span>
        <span>{{ aluno && (aluno.ficha_medica.alergicoAlimento ? aluno.ficha_medica.alergicoAlimento : 'Não informado') }}</span>
      </div>
      <div class="content-esquerda">
        <span>O aluno possui doença congênita?</span>
        <span>{{ aluno && (aluno.ficha_medica.doencaCongenita ? aluno.ficha_medica.doencaCongenita : 'Não informado') }}</span>
      </div>
      <div class="content-esquerda">
        <span>O aluno é fumante?</span>
        <span>{{ aluno && (aluno.ficha_medica.fumante ? aluno.ficha_medica.fumante : 'Não informado') }}</span>
      </div>
      <div class="content-esquerda">
        <span>O aluno já contraiu caxumba?</span>
        <span>{{ aluno && (aluno.ficha_medica.caxumba ? aluno.ficha_medica.caxumba : 'Não informado') }}</span>
      </div>
      <div class="content-esquerda">
        <span>O aluno já contraiu sarampo?</span>
        <span>{{ aluno && (aluno.ficha_medica.sarampo ? aluno.ficha_medica.sarampo : 'Não informado') }}</span>
      </div>


    </div>
    <div class="direita">
      <div class="content-direita">
        <span>O aluno já contraiu rubeola?</span>
        <span>{{ aluno && (aluno.ficha_medica.rubeola ? aluno.ficha_medica.rubeola : 'Não informado') }}</span>
      </div>
      <div class="content-direita">
        <span>O aluno já contraiu catapora?</span>
        <span>{{ aluno && (aluno.ficha_medica.catapora ? aluno.ficha_medica.catapora : 'Não informado') }}</span>
      </div>
      <div class="content-direita">
        <span>O aluno já contraiu escarlatina?</span>
        <span>{{ aluno && (aluno.ficha_medica.escarlatina ? aluno.ficha_medica.escarlatina : 'Não informado') }}</span>
      </div>
      <div class="content-direita">
        <span>O aluno faz algum tratamento médico?</span>
        <span>{{ aluno && (aluno.ficha_medica.tratamentoMedico ? aluno.ficha_medica.tratamentoMedico : 'Não informado') }}</span>
      </div>
      <div class="content-direita">
        <span>O aluno está ingerindo medicação específica?</span>
        <span>{{ aluno && (aluno.ficha_medica.medicaoEspecifica ? aluno.ficha_medica.medicaoEspecifica : 'Não informado') }}</span>
      </div>
      <div class="content-direita">
        <span>O aluno tem acompanhamento médico ou psicológico?</span>
        <span>{{ aluno && (aluno.ficha_medica.acompanhamentoMedico ? aluno.ficha_medica.acompanhamentoMedico : 'Não informado') }}</span>
      </div>
      <div class="content-direita">
        <span>O aluno tem restrição a alguma atividade física?</span>
        <span>{{ aluno && (aluno.ficha_medica.restricaoAtividadeFisica ? aluno.ficha_medica.restricaoAtividadeFisica : 'Não informado') }}</span>
      </div>
      <div class="content-direita">
        <span>O aluno sofreu alguma fratura ou trauma?</span>
        <span>{{ aluno && (aluno.ficha_medica.traumaFratura ? aluno.ficha_medica.traumaFratura : 'Não informado') }}</span>
      </div>
      <div class="content-direita">
        <span>O aluno possui algum plano de saúde?</span>
        <span>{{ aluno && (aluno.ficha_medica.planoSaude ? aluno.ficha_medica.planoSaude : 'Não informado') }}</span>
      </div>
      <div class="content-direita">
        <span>Em caso de emergência, autorizo levar meu(minha) filho(a) para o Hospital ou Clínica mais próximos:</span>
        <span>{{ aluno && (aluno.ficha_medica.resposavelLevarParaHospital ? aluno.ficha_medica.resposavelLevarParaHospital : 'Não informado') }}</span>
      </div>
      <div class="content-direita">
        <span>Em caso de emergência, caso não seja encontrado pais ou responsáveis, avisar:</span>
        <span>{{ aluno && (aluno.ficha_medica.emergenciaNomeResponsavel ? aluno.ficha_medica.emergenciaNomeResponsavel : 'Não informado') }}</span>
      </div>
    </div>
    <div class="find">
      <tgt-button [size]="'middle'" [border]="false" [color]="'primary'" [fieldButton]="'outline'" [icon]="'edit'"
        (click)="editarForm()">Editar Dados</tgt-button>
    </div>
    }


  </section>
  }
  @if(editar) {
  <section class="editar">
    <div class="ficha-medica">
      <!-- <h5>Carteirinha de Vacinação</h5>
          <div class="doc-ficha-medica" (click)="fichaMedica.click()">
            <div class="doc">
              <input type="file" multiple hidden #fichaMedica (change)="docCarteiraVacinacao($event)">
              <span class="material-symbols-outlined">
                upload
              </span>
            </div>
            <div class="infos">
              <span>Clique para carregar</span>
              <p>Tamanho máximo do arquivo: 200MB</p>
              @if(fileDocumentoPrimeiroResponsavel) {
              <span>{{fileDocumentoPrimeiroResponsavel.name}}</span>
              } @else {
              }

              @if(this.fileDocumentoPrimeiroResponsavel.size) {
              <p>{{(this.fileDocumentoPrimeiroResponsavel.size / (1024 * 1024)).toFixed(2)}} MB</p>
              } @else {
              }
            </div>
          </div> -->

      <div class="infos">
        <tgt-input-icon [disabled]="true"
          [error]="formFichaMedica.controls.altura.value === '' ? camposObrigatoriosFormFichaMedica : false"
          [control]="formFichaMedica.controls.altura" [border]="true" [placeholder]="'Altura (m)*'"
          [type]="'number'"></tgt-input-icon>

        <tgt-input-icon [error]="formFichaMedica.controls.peso.value === '' ? camposObrigatoriosFormFichaMedica : false"
          [control]="formFichaMedica.controls.peso" [border]="true" [placeholder]="'Peso (kg)*'"
          [type]="'number'"></tgt-input-icon>

        <tgt-input-icon
          [error]="formFichaMedica.controls.tipoSanguineo.value === '' ? camposObrigatoriosFormFichaMedica : false"
          [control]="formFichaMedica.controls.tipoSanguineo" [border]="true" [placeholder]="'Tipo Sanguíneo*'"
          [type]="'text'"></tgt-input-icon>
      </div>

      <div class="infos">

        <tgt-input-icon [control]="formFichaMedica.controls.carteiraSus" [border]="true"
          [placeholder]="'Número da Carteira do SUS'" [type]="'text'"></tgt-input-icon>

        <tgt-input-icon [control]="formFichaMedica.controls.fatorrh" [border]="true" [placeholder]="'Fator RH'"
          [type]="'text'"></tgt-input-icon>
      </div>

      <span>Em caso de emergência, autorizo levar meu(minha) filho(a) para o Hospital ou Clínica mais próximos:*</span>
      <tgt-input-icon
        [error]="formFichaMedica.controls.resposavelLevarParaHospital.value === '' ? camposObrigatoriosFormFichaMedica : false"
        [control]="formFichaMedica.controls.resposavelLevarParaHospital" [border]="true" [placeholder]="'Responsável*'"
        [type]="'text'"></tgt-input-icon>

      <span>Em caso de emergência, caso não seja encontrado pais ou responsáveis, avisar:*</span>
      <div class="infos">
        <tgt-input-icon
          [error]="formFichaMedica.controls.emergenciaNomeResponsavel.value === '' ? camposObrigatoriosFormFichaMedica : false"
          [control]="formFichaMedica.controls.emergenciaNomeResponsavel" [border]="true" [placeholder]="'Nome*'"
          [type]="'text'"></tgt-input-icon>
        <tgt-input-icon
          [error]="formFichaMedica.controls.emergenciaParentesco.value === '' ? camposObrigatoriosFormFichaMedica : false"
          [control]="formFichaMedica.controls.emergenciaParentesco" [border]="true" [placeholder]="'Parentesco*'"
          [type]="'text'"></tgt-input-icon>
      </div>
      <div class="infos">
        <tgt-input-icon
          [error]="formFichaMedica.controls.emergenciaTelefone.value === '' ? camposObrigatoriosFormFichaMedica : false"
          [control]="formFichaMedica.controls.emergenciaTelefone" [border]="true" [placeholder]="'Telefone*'"
          [mask]="'(00) 00000-0000'"></tgt-input-icon>
        <tgt-input-icon
          [error]="formFichaMedica.controls.emergenciaCelular.value === '' ? camposObrigatoriosFormFichaMedica : false"
          [control]="formFichaMedica.controls.emergenciaCelular" [border]="true" [placeholder]="'Celular*'"
          [mask]="'(00) 00000-0000'"></tgt-input-icon>
      </div>

      <div class="checkbox">
        <tgt-checkbox [checked]="formFichaMedica.controls.espectroAustista.value"
          (checkedChange)="espectroAutista($event)">O aluno apresenta algum diagnóstico relacionado ao espectro autista
          ou outras condições do neurodesenvolvimento?</tgt-checkbox>
      </div>

      <tgt-input-icon [control]="formFichaMedica.controls.espectroAustistaTexto" [disabled]="true" [border]="true"
        [placeholder]="'Descreva aqui...'" [type]="'text'"></tgt-input-icon>

      <div class="checkbox">
        <tgt-checkbox [checked]="formFichaMedica.controls.planoSaude.value" (checkedChange)="planoSaude($event)">O aluno
          possui plano de saúde?</tgt-checkbox>
      </div>

      <tgt-input-icon [control]="formFichaMedica.controls.nomesPlanosSaude" [disabled]="true" [border]="true"
        [placeholder]="'Quais?'" [type]="'text'"></tgt-input-icon>

      <div class="checkbox">
        <tgt-checkbox [checked]="formFichaMedica.controls.alergicoMedicamento.value"
          (checkedChange)="alergicoMedicamento($event)">O aluno é alérgico a algum medicamento?</tgt-checkbox>
      </div>

      <tgt-input-icon [control]="formFichaMedica.controls.textoAlergicoMedicamento" [disabled]="true" [border]="true"
        [placeholder]="'Quais?'" [type]="'text'"></tgt-input-icon>

      <div class="checkbox">
        <tgt-checkbox [checked]="formFichaMedica.controls.alergicoAlimento.value"
          (checkedChange)="alergicoAlimento($event)">O aluno é alérgico a algum alimento?</tgt-checkbox>
      </div>

      <tgt-input-icon [control]="formFichaMedica.controls.textoAlergicoAlimento" [disabled]="true" [border]="true"
        [placeholder]="'Quais?'" [type]="'text'"></tgt-input-icon>

      <div class="checkbox">
        <tgt-checkbox [checked]="formFichaMedica.controls.doencaCongenita.value" (checkedChange)="congenita($event)">O
          aluno possui doença congêtina?</tgt-checkbox>
      </div>

      <tgt-input-icon [control]="formFichaMedica.controls.textoDoencaCongenita" [disabled]="true" [border]="true"
        [placeholder]="'Quais?'" [type]="'text'"></tgt-input-icon>

      <div class="checkbox">
        <tgt-checkbox [checked]="formFichaMedica.controls.fumante.value" (checkedChange)="fumante($event)">O aluno é
          fumante?</tgt-checkbox>
        <tgt-checkbox [checked]="formFichaMedica.controls.caxumba.value" (checkedChange)="caxumba($event)">O aluno já
          contraiu caxumba?</tgt-checkbox>
        <tgt-checkbox [checked]="formFichaMedica.controls.sarampo.value" (checkedChange)="sarampo($event)">O aluno já
          contraiu sarampo?</tgt-checkbox>
        <tgt-checkbox [checked]="formFichaMedica.controls.rubeola.value" (checkedChange)="rubeola($event)">O aluno já
          contraiu rubeola?</tgt-checkbox>
        <tgt-checkbox [checked]="formFichaMedica.controls.catapora.value" (checkedChange)="catapora($event)">O aluno já
          contraiu catapora?</tgt-checkbox>
      </div>

      <div class="checkbox">
        <tgt-checkbox [checked]="formFichaMedica.controls.escarlatina.value" (checkedChange)="escarlatina($event)">O
          aluno já contraiu escarlatina?</tgt-checkbox>
        <tgt-checkbox [checked]="formFichaMedica.controls.coqueluche.value" (checkedChange)="coqueluche($event)">O aluno
          já contraiu coqueluche?</tgt-checkbox>
        <tgt-checkbox [checked]="formFichaMedica.controls.epiletico.value" (checkedChange)="epiletico($event)">O aluno é
          epilético?</tgt-checkbox>
        <tgt-checkbox [checked]="formFichaMedica.controls.hemofilico.value" (checkedChange)="hemofilico($event)">O aluno
          é hemofílico?</tgt-checkbox>
        <tgt-checkbox [checked]="formFichaMedica.controls.hipertensao.value" (checkedChange)="hipertensao($event)">O
          aluno tem hipertensão?</tgt-checkbox>
      </div>

      <div class="checkbox">
        <tgt-checkbox [checked]="formFichaMedica.controls.asmatico.value" (checkedChange)="asmatico($event)">O aluno é
          asmático?</tgt-checkbox>
        <tgt-checkbox [checked]="formFichaMedica.controls.diabetico.value" (checkedChange)="diabetico($event)">O aluno é
          diabético?</tgt-checkbox>
        <tgt-checkbox [checked]="formFichaMedica.controls.insulina.value" (checkedChange)="insulina($event)">Depende de
          insulina?</tgt-checkbox>
      </div>

      <div class="checkbox">
        <tgt-checkbox [checked]="formFichaMedica.controls.tratamentoMedico.value"
          (checkedChange)="tratamentoMedico($event)">O aluno faz tratamento médico?</tgt-checkbox>
      </div>

      <tgt-input-icon [control]="formFichaMedica.controls.textoTratamentoMedico" [disabled]="true" [border]="true"
        [placeholder]="'Quais?'" [type]="'text'"></tgt-input-icon>

      <div class="checkbox">
        <tgt-checkbox [checked]="formFichaMedica.controls.medicaoEspecifica.value"
          (checkedChange)="medicaoEspecifica($event)">O aluno está ingerindo medicação específica?</tgt-checkbox>
      </div>

      <tgt-input-icon [control]="formFichaMedica.controls.textoMedicacaoEspecifica" [disabled]="true" [border]="true"
        [placeholder]="'Quais?'" [type]="'text'"></tgt-input-icon>


      <div class="checkbox">
        <tgt-checkbox [checked]="formFichaMedica.controls.acompanhamentoMedico.value"
          (checkedChange)="acompanhamentoMedico($event)">O aluno tem acompanhamento médico ou
          psicológico?</tgt-checkbox>
      </div>

      <tgt-input-icon [control]="formFichaMedica.controls.textoAcompanhamentoMedico" [disabled]="true" [border]="true"
        [placeholder]="'Quais?'" [type]="'text'"></tgt-input-icon>



      <div class="checkbox">
        <tgt-checkbox [checked]="formFichaMedica.controls.restricaoAtividadeFisica.value"
          (checkedChange)="restricaoAtividadeFisica($event)">O aluno tem restrição a alguma atividade
          física?</tgt-checkbox>
      </div>

      <tgt-input-icon [control]="formFichaMedica.controls.textoRestricaoAtividadeFisica" [disabled]="true"
        [border]="true" [placeholder]="'Quais?'" [type]="'text'"></tgt-input-icon>


      <div class="checkbox">
        <tgt-checkbox [checked]="formFichaMedica.controls.traumaFratura.value" (checkedChange)="traumaFratura($event)">O
          aluno sofreu alguma fratura ou trauma?</tgt-checkbox>
      </div>

      <tgt-input-icon [control]="formFichaMedica.controls.textoTraumaFratura" [disabled]="true" [border]="true"
        [placeholder]="'Quais?'" [type]="'text'"></tgt-input-icon>

    </div>
    <div class="actions">
      <tgt-button (click)="editarForm()" [color]="'primary'" [border]="false" [size]="'small'"
        [fieldButton]="'outline'">Cancelar</tgt-button>
      <tgt-button (click)="salvarFichaMedica()" [color]="'primary'" [icon]="'save'">Salvar</tgt-button>
    </div>
  </section>
  }
  }
  @case('remedios'){
  @if(!editarRemedio){
  <section class="desktop">
    @for (item of medicamentos; track $index) {
    <div class="esquerda">
      <div class="content-esquerda">
        <span>Nome do Remédio</span>
        <span>{{item.nome}}</span>
      </div>
      <div class="content-esquerda">
        <span>Horário</span>
        <span>{{getHoraMinuto(item.medicacao_horarios[0].horario)}}</span>
      </div>
      <div class="content-esquerda">
        <span>Quantidade</span>
        <span>{{item.medicacao_horarios[0].dosagem}}</span>
      </div>
      <div class="content-esquerda">
        <span>Unidade</span>
        <span>{{item.medicacao_horarios[0].medicacao_unidade.nome}}</span>
      </div>
      <div class="content-esquerda">
        <span>Observação</span>
        <span>{{item.observacao}}</span>
      </div>
    </div>
    <div class="deletar" (click)="deletarRemedio(item.documentId)">
      <span class="material-symbols-outlined">
        delete
      </span>
      <p>Excluir</p>
    </div>

    } @empty {
    <div class="empty">
      <img src="assets/images/turma-empty.png" alt="">
        <span>Nenhum medicamento encontrado !</span>
    </div>
    }

    <div class="find">
      @if(!editar) {

      <tgt-button [size]="'middle'" [border]="false" (click)="editarRemedios()" [color]="'primary'"
        [fieldButton]="'field'" [icon]="'add'">Cadastrar</tgt-button>
      }
    </div>
  </section>
  } @else {
  <section class="editar">
    <div class="ficha-medica">

      <div class="infos">
        <tgt-input-icon [control]="formMedicacao.controls.nome" [disabled]="true" [border]="true"
          [placeholder]="'Nome do remédio*'" [type]="'text'"></tgt-input-icon>
        <tgt-input-icon [control]="formMedicacaoHorario.controls.horario" [border]="true" [placeholder]="'Horário*'"
          [type]="'time'"></tgt-input-icon>
        <tgt-select [label]="'Unidade'" (changeOption)="changeMedicacaoUnidade($event)"
          [options]="optionsRemedios"></tgt-select>
        <tgt-input-icon [control]="formMedicacaoHorario.controls.quantidade" [disabled]="true" [border]="true"
          [placeholder]="'Quantidade*'" [type]="'number'"></tgt-input-icon>
        <tgt-textarea [control]="formMedicacao.controls.observacao" [placeholder]="'Observação*'"
          [linhas]="5"></tgt-textarea>
      </div>
      <div class="actions">
        <tgt-button [color]="'primary'" [border]="false" [size]="'small'" (click)="editarRemedios()"
          [fieldButton]="'outline'">Cancelar</tgt-button>
        <tgt-button [color]="'primary'" [icon]="'save'" (click)="salvarRemedio()">Salvar</tgt-button>
      </div>
    </div>

  </section>


  }

  }
  }




</main>
